<template>
  <generic-view
    :title="$t('transactions')"
    icon="list"
    :header_buttons="header_buttons"
    ref="transactions_container"
    :show_refresh="true"
    @refresh="getData"
  >
    <table
      class="ui very compact selectable celled striped table"
      ref="transaction_table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("type") }}</th>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("amount") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <!-- <pre> {{transactions}} </pre> -->
    <template v-for="(mdl, index) in transaction_modals">
      <component
        :is="mdl"
        :key="index"
        :account_in="$props.account_in"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
    <template v-for="(mdl, index) in detail_modals">
      <component
        :is="mdl"
        :key="index"
        :transaction_in="selected_transaction"
        v-on:destroy="destroy_detail"
      ></component>
    </template>
  </generic-view>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  init_json_local_data_datables,
} from "@/utils";
import TransactionModal from "./TransactionModal";
import TransactionDetailModal from "./TransactionDetailModal";
import GenericView from "@/components/GenericContainer";
import filters from "@/filters";

export default {
  name: "AccountTransactionPlugin",
  filters: filters,
  props: {
    module: Object,
    account_in: Object,
  },
  components: {
    "generic-view": GenericView,
  },
  data() {
    return {
      transactions: [],
      transaction_modals: [],
      detail_modals: [],
      selected_transaction: {},
      header_buttons: [
        {
          icon: "green plus",
          click: this.add,
          tooltip: this.$t("register transaction"),
        },
      ],
    };
  },
  methods: {
    add() {
      this.transaction_modals.push(TransactionModal);
    },
    destroy() {
      this.transaction_modals = [];
      this.selected_transaction = {};
    },
    destroy_detail() {
      this.detail_modals = [];
      this.selected_transaction = {};
    },
    succedded() {
      this.getData();
    },
    edit(transaction) {
      this.selected_transaction = transaction;
      this.detail_modals.push(TransactionDetailModal);
    },
    getData() {
      let vm = this;
      if (!vm.account_in || !vm.account_in.uuid) {
        setTimeout(() => {
          vm.getData();
        }, 200);
      } else {
        local_api(vm, "post", "/account_transaction/do-get-list", {
          uuid: vm.account_in.uuid,
        })
          .then((r) => {
            vm.transactions = r.map((_r) => {
              _r.acc_transaction_type.setup = JSON.parse(
                _r.acc_transaction_type.setup,
              );
              return _r;
            });
            setTimeout(() => {
              let columns = [
                {
                  data: function(row) {
                    return row.acc_transaction_type.name;
                  },
                },
                {
                  data: function(row) {
                    let ent_setup = enterprise_setup(vm);
                    return filters.formatDate(
                      row.create_date,
                      ent_setup.detailed_date_format,
                    );
                  },
                },
                {
                  data: function(row) {
                    return filters.formatCurrency(row.amount);
                  },
                },
              ];

              let onSelect = (data) => {
                vm.edit(data);
              };
              let onCreatedRow = (row, data) => {
                if (
                  data.acc_transaction_type &&
                  data.acc_transaction_type.setup
                ) {
                  switch (data.acc_transaction_type.setup.affect) {
                    case "D":
                      window.jQuery(row).addClass("warning");
                      break;
                    default:
                      break;
                  }
                }

                setTimeout(() => {
                  window.jQuery(".ui.progress").progress();
                }, 200);
              };

              init_json_local_data_datables(
                vm,
                vm.$refs.transaction_table,
                vm.transactions,
                columns,
                onSelect,
                onCreatedRow,
              );
            }, 500);
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
